import { jsx as o, jsxs as h } from "react/jsx-runtime";
import i from "./index10.js";
import { token as x, Flex as r, Box as c } from "@bynder/design-system";
import { DimensionControl as f } from "./index45.js";
import { AspectRatioControl as P } from "./index46.js";
import { useAspectProperties as A, useImageCropperActions as s, useImageProperties as D, useMinimumCropValues as S, useCropPixelProperties as j } from "./index15.js";
const R = () => {
  const { aspect: n, isLocked: t } = A(), p = s(), m = (e) => {
    p.setAspect({ aspect: e, isLocked: t }, !0);
  }, l = D(), a = S(), d = j(), { setCropDimension: C } = s();
  return /* @__PURE__ */ o(k, { children: /* @__PURE__ */ o(r, { direction: "column", children: /* @__PURE__ */ o(y, { children: /* @__PURE__ */ h(r, { direction: "column", gap: "4", children: [
    /* @__PURE__ */ o(
      P,
      {
        aspect: n,
        isLocked: t,
        onChange: m
      }
    ),
    /* @__PURE__ */ o(
      f,
      {
        imageProperties: l,
        minimumCropValues: a,
        cropPixelProperties: d,
        onChange: (e, u, g) => {
          C(e, u, g);
        },
        aspect: n
      }
    )
  ] }) }) }) });
}, k = i(c)`
  flex-grow: 1;
`, y = i(c)`
  padding: 0px ${x.spacing6};
`;
export {
  R as ControlSection
};
